/**
 * @file Settings
 */

/**
 * Settings component
 */
const vSettings = () => {
    const settings = document.querySelector('.v-settings');

    if (!settings) {
        return;
    }

    const fileInput = settings.querySelector('.v-settings__item-input-wrap input[type=file]');
    fileInput.addEventListener('change', () => {
        if (fileInput.files.length > 0) {
            const fileName = document.querySelector('.v-settings__item-input-wrap .file-name');
            fileName.textContent = fileInput.files[0].name;
        }
    });
};

export default vSettings;
